import { Component } from '../Component'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'
import { inject } from '../../services/di'
import { LocationService } from '../../services/LocationService'
import { EventService } from '../../services/EventService'
import { LinkService } from '../../services/LinkService'

const LONG_TIMEOUT = 10 * 1000
const SHORT_TIMEOUT = 4 * 1000
enum ItemEvent {
    ADDED,
    REMOVED,
}

@element('flipp-items-toast')
export class ItemsToast extends Component<any, any> {
    @inject location: LocationService
    @inject eventService: EventService
    @inject linkService: LinkService

    state: {
        timer: any
        visibleMessage: string
        timestamp: number
        event: ItemEvent
    } = {
        timer: null,
        visibleMessage: '',
        timestamp: 0,
        event: null,
    }

    onAttach() {
        window.addEventListener('flipp-item-added', this.onItemAdded.bind(this))
        window.addEventListener(
            'flipp-item-removed',
            this.onItemRemoved.bind(this)
        )
    }

    onDetach() {
        window.removeEventListener(
            'flipp-item-added',
            this.onItemAdded.bind(this)
        )
        window.removeEventListener(
            'flipp-item-removed',
            this.onItemRemoved.bind(this)
        )
    }

    onItemAdded(e: any) {
        this.state.event = ItemEvent.ADDED
        if (!this.state.visibleMessage) {
            this.state.visibleMessage =
                e.detail.count > 1
                    ? `${e.detail.count} ${i18n('items_added')}`
                    : i18n('item_added')
            this.invalidate()
            this.state.timestamp = Date.now()
        } else {
            const diff = Date.now() - this.state.timestamp
            const timeout = diff > SHORT_TIMEOUT ? 0 : SHORT_TIMEOUT - diff
            setTimeout(() => {
                this.state.visibleMessage = ''
                this.invalidate()
                setTimeout(() => {
                    this.onItemAdded({ detail: { count: e.detail.count } })
                    this.invalidate()
                })
            }, timeout)
        }
    }

    onItemRemoved() {
        this.state.event = ItemEvent.REMOVED
        if (!this.state.visibleMessage) {
            this.state.visibleMessage = i18n('item_removed')
            this.invalidate()
            this.state.timestamp = Date.now()
        } else {
            setTimeout(() => {
                // need to remove visible message first
                this.state.visibleMessage = ''
                this.invalidate()
                setTimeout(() => {
                    // display new message only after hiding old one
                    this.onItemRemoved()
                    this.invalidate()
                })
            }, 0)
        }
    }

    invalidate() {
        // Clear the timer before invalidating if it's active;
        if (this.state.timer) {
            clearTimeout(this.state.timer)
        }
        return super.invalidate()
    }

    onRender() {
        if (this.state.visibleMessage) {
            this.classList.add('visible')
            if (this.location.locale === 'fr-ca') {
                this.classList.add('fr')
            }
            this.state.timer = setTimeout(() => {
                this.state.timer = null
                this.hide_()
            }, LONG_TIMEOUT)
        }
    }

    render() {
        const added = this.state.event === ItemEvent.ADDED
        if (this.state.visibleMessage) {
            return (
                <div class={`toast-wrapper ${added ? 'added' : 'removed'}`}>
                    <div class="message-container">
                        <div class="message-bold">
                            {this.state.visibleMessage}
                        </div>
                        <div>
                            {added
                                ? i18n('to_your_shopping_list')
                                : i18n('from_your_shopping_list')}
                        </div>
                    </div>
                    <button onClick={this.onNavigate.bind(this)}>
                        {i18n('view')}
                    </button>
                </div>
            )
        } else {
            return null
        }
    }

    onNavigate() {
        const d = document.getElementById('flipp-flyer-item-dialog')
        this.linkService.execute('shopping_list', d)
    }

    private hide_ = (e?: MouseEvent) => {
        if (e) {
            e.preventDefault()
        }
        if (this.state.timer !== -1) {
            clearTimeout(this.state.timer)
            this.state.timer = null
        }
        this.classList.remove('visible')
        this.state.visibleMessage = ''
        this.state.timestamp = 0
    }
}
